import React from "react";
import { APP_VERSION, APP_UPDATED } from "../version";

const fmt = (iso) => {
  try {
    return new Date(iso).toLocaleString("it-IT", {
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const Footer = () => (
  <footer
    className="border-t border-slate-200 bg-white/60 py-3 px-4 sm:px-6 lg:px-8"
    data-testid="app-footer"
  >
    <div className="max-w-[1150px] mx-auto flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-xs text-slate-400">
      <span>StorMi Preventivatore</span>
      <span className="text-slate-300">·</span>
      <span data-testid="app-version">v{APP_VERSION}</span>
      <span className="text-slate-300">·</span>
      <span data-testid="app-updated">aggiornato il {fmt(APP_UPDATED)}</span>
    </div>
  </footer>
);
